import { render, staticRenderFns } from "./Impressions.vue?vue&type=template&id=46d579a2&scoped=true&"
import script from "./Impressions.vue?vue&type=script&lang=js&"
export * from "./Impressions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d579a2",
  null
  
)

export default component.exports